// @flow
export const PREFERRED_LANGUAGE_EXPIRATION_DAYS = 3652 // ten years

export const PREFERRED_LANGUAGE_EXPIRATION_MILLISECONDS =
  PREFERRED_LANGUAGE_EXPIRATION_DAYS * 24 * 60 * 60 * 1000 // ten years

export const PREFERRED_CURRENCY_EXPIRATION_DAYS = 3652 // ten years
